/**
 * Utility functions for subdomain detection and beta feature checks
 */

/**
 * Check if the current hostname is the vitals subdomain
 *
 * @returns true if on vitals subdomain, false otherwise
 */
export const isVitalsSubdomain = (): boolean => {
  return window.location.hostname === "vitals.circadia.link";
};

/**
 * Check if user has vitals-ai beta feature enabled
 *
 * @param betaFeaturesAllowedList - Array of beta features from Redux state
 * @returns true if "vitals-ai" is in the beta features list, false otherwise
 */
export const hasVitalsAIBetaFeature = (
  betaFeaturesAllowedList?: string[]
): boolean => {
  return (
    Array.isArray(betaFeaturesAllowedList) &&
    betaFeaturesAllowedList.includes("vitals-ai")
  );
};
